import React from "react";
import { Link } from "react-router-dom";

const PmbokSevenToc = ({ onClose }) => {
  const body = document.querySelector("body")
  body.classList.add("overflow-hidden");
  const closeModal = () => {
    onClose();
    body.classList.remove("overflow-hidden");
  };
  return (
    <div className="text-gray-brand-700">
      <h1 className='resource-title text-2xl font-bold text-center'>Welcome to PMBOK<sup>&reg;</sup> Guide - Seventh Edition!</h1>
      <h2 className='resource-toc font-bold text-center mt-6'>Table of Contents</h2>
      <h3 className='resource-section font-bold my-5 font-bold'>THE STANDARD FOR PROJECT MANAGEMENT</h3>
      <h4 className='resource-topic pl-8 font-bold mb-2'>1 INTRODUCTION</h4>
      <Link
        className="inline-block resource-fragment ml-16 mb-2"
        to={`/posts/0a66dcac-a55f-417b-9176-3d295765c9fb/54420d7f-cf0e-47cb-a874-0f7d98cbcb7b`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.1 Purpose of The Standard for Project Management</p>
      </Link><br />
      <Link
        className="inline-block resource-fragment ml-16 mb-2"
        to={`/posts/e09d49ca-10a4-4466-abbd-6a3358021a0d/d1a2ed62-4663-46f4-a391-09751ed65130`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.2 Key Terms and Concepts</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/247b0432-86f9-4149-9e4f-79afa0d67237/5d17b72a-4798-4291-82fd-658057250638`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.3 Audience for this Standard</p>
      </Link><br />
      <h4 className='resource-topic pl-8 font-bold mb-2'>2 A SYSTEM FOR VALUE DELIVERY</h4>
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/5a93e71d-fc53-40b4-8897-891db741e0ac/ea5044ac-6c6e-4795-8f79-9ce57a3b8f35`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1 Creating Value</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/3bfa7b30-ffe1-4695-921f-f3ce8878a322/e25f66c2-6f6e-40e2-a78e-697ee72d2448`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1.1 Value Delivery Components</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/57917688-1064-48be-9f2b-abb281257a12/79778915-e2e9-4099-aced-6d9d62439618`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1.2 Information Flow</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/0353f440-129a-4f04-a343-b7f69ec219fc/43b7d522-d177-4c04-af25-51aed4c9b4d8`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2 Organizational Governance Systems</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/ec1eff1c-ae86-4e89-87a8-5dfa3b991acd/d37b171e-faa1-44bc-89f1-f23dacf1b160`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3 Functions Associated with Projects</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/64b675f4-d5ba-4b21-b1a3-794830e10add/dadc8d78-8694-442d-bb8b-dd706fb8629b`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.1 Provide Oversight and Coordination</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/9e174c63-424e-4dc2-a6f2-6b773a0ee74d/50cef4b2-bae3-430e-b6e5-c0521c42ab2b`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.2 Present Objectives and Feedback</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/9ae91a46-698a-439c-bfb3-953f2a31b086/a7950d17-1401-481d-aae5-e0fcc43b14ab`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.3 Facilitate and Support</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/62d2eaea-146d-4f6d-814d-d0218e28f31f/98081701-1690-4de4-b52c-d9e6212ab58e`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.4 Perform Work and Contribute Insights</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/6aee4697-5160-4989-b85f-e198001e7740/43afab01-1324-4e73-abbd-b26833e4562f`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.5 Apply Expertise</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/fea17252-49fa-4ac5-8c96-c5c807ae7d99/e4f4d017-c055-418c-b40a-9d2c95348a30`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.6 Provide Business Direction and Insight</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/f8c04a3d-9543-4d22-950d-7e8fd09515e4/a04aab16-5058-44ed-8c36-a0578c609498`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.7 Provide Resources and Direction</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/2bff5920-1d43-4260-93b8-ad5e35a5fff1/0ffda2a4-cae7-43c1-812c-da5a72118215`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.8 Maintain Governance</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/8caf84d4-7c96-425c-bc3c-3f9671544e3f/bf1ad8b9-e2bb-4b37-9e25-b7472d9b1705`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4 The Project Environment</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/418c15d5-3fb8-4a2d-a657-11a074891bd1/fd91140a-0aa8-48e3-88d4-e7fe23a06128`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.1 Internal Environment</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/3a834489-b5fb-4de3-a4a0-a74946bebafc/6ad88a59-fee2-4ac5-961e-7b4e08a337f2`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.2 External Environment</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/d50667aa-1f1f-495e-946d-e17e11090ce7/6661221d-b2fe-4adb-894f-8ae6034c965f`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5 Product Management Considerations</p>
      </Link><br />
      <h4 className='resource-topic pl-8 font-bold mb-2'>3 PROJECT MANAGEMENT PRINCIPLES</h4>
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/e4db82f1-be35-4541-b047-03c0b57c6007/01326b18-6e54-4786-be25-2a0ebad93e4e`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.1 Be a Diligent, Respectful, and Caring Steward</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/52bea68d-76c3-4aa8-ae02-9606f80c4a44/7b7d75e7-ef17-4488-b246-8d99207bd717`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.2 Create a Collaborative Project Team Environment</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/6a8b4621-9207-4ed4-9e94-8f3897491d88/35ef3044-10b0-44a0-8f49-50397ba96fda`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3 Effectively Engage with Stakeholders</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/b8d7634e-86e3-4434-b503-15c79b5caa78/571713ef-a2df-4746-915c-4b4448a30634`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.4 Focus on Value</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/b7fa13b5-bb1a-4111-a411-52a6d2e09b9b/d204576b-f61f-4238-9b52-1c09e38ce8e4`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5 Recognize, Evaluate, and Respond to System Interactions</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/ec1d6c2d-80ad-49f4-814d-b9f9650ca3fc/83013e43-6ce0-4f09-9f51-29b7605dd7e9`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.6 Demonstrate Leadership Behaviors</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/d951ef46-5b61-4912-bf20-7e634b07f127/36df02bf-ccbe-4e36-882f-2acd96e83afb`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.7 Tailor Based on Context</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/d9f87521-9369-4177-87b3-f616a17c1998/e4067f9f-40e3-461b-9b03-4e01d98ffe5b`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.8 Build Quality into Processes and Deliverables</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/40a7722c-2771-46f8-9482-991acb204c62/47ee6ed3-0384-4899-b4dd-93bdc61dae05`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.9 Navigate Complexity</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/9d78a7ad-ee06-4e0c-867a-115434d75d3f/9d40dd24-b1d5-4b1c-a4ad-b54afc1e4df4`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.10 Optimize Risk Responses</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/c6c829cc-3ae7-4e84-bb11-e91ba61ddc40/06955768-6069-49bf-a486-f4d034a0c0c4`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.11 Embrace Adaptability and Resiliency</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/d0fd3f9e-28f7-4572-90fc-ebe4fe2719b7/df897101-f053-4ca1-9898-bd0a219c8b7b`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.12 Enable Change to Achieve the Envisioned Future State References</p>
      </Link><br />
      <h3 className='resource-section font-bold my-4 font-bold'>A GUIDE TO THE PROJECT MANAGEMENT BODY OF KNOWLEDGE (PMBOK<sup>&reg;</sup> GUIDE)</h3>
      <Link
        className='inline-block resource-topic pl-8 font-bold mb-2'
        to={`/posts/dc110ab9-6f2f-424e-a362-4cce19f8f077/04c444f1-52f3-4c74-8d43-fef183a411b6`}
        target="_self"
        onClick={closeModal}
      >
        <h4 className='resource-topic pl-8 font-bold mb-2'>1.INTRODUCTION</h4>
      </Link><br />

      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/bf44d056-b110-478c-86c5-b4a76a68ec0c/bae5f2e3-476b-4244-bcdb-b55dfc7c8a5e`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.1 Structure of the PMBOK<sup>&reg;</sup> Guide</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/49d75a5b-9f32-455f-b3c7-f23d4f2bca69/b4123ac7-6a32-4851-9037-f9e3a6434428`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.2 Relationship of the PMBOK<sup>&reg;</sup> Guide and The Standard for Project Management</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/436fd8a7-cc18-474b-9636-a2fc67a14b6c/5d67564d-3f1b-47e6-8681-c33d845bb736`}
        target="_self"
        onClick={closeModal}
      >
        <p >1.3 Changes to the PMBOK<sup>&reg;</sup> Guide</p>
      </Link><br />
      <h4 className='resource-topic pl-8 font-bold mb-2'>2. PROJECT PERFORMANCE DOMAINS</h4>
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/bc1446b3-5921-4fd6-8a8a-af281c02f7ba/1cdd3940-db50-460e-9815-0fe45e806812`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1 Stakeholder Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/400cb244-7d6c-4bc5-8b0f-7a37163fe6dd/d5320921-3416-48e1-a39e-361bcf5f02dc`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1.1 Stakeholder Engagement</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/227dd0d7-5cbf-4e2c-9196-bfe79b32f2d9/0c1ad8b9-3fbe-4639-9a41-f8f2cc782394`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1.2 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/6f507534-92d0-49c4-afa2-529b13516d77/09833aff-ff10-45f4-b9f4-2a661040c6d4`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.1.3 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/f7cd9dce-ceea-4823-be6c-fc1106ecef1a/3c979162-b327-4e0b-a500-e08ff37b186f`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2 Team Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/dc9256a9-6aeb-4ebe-b7a8-78f2860a1e0f/c0a98052-6c55-48f4-be2f-4dbaa23a3398`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.1 Project Team Management and Leadership</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/bc736382-ef8f-48e6-8dfd-42c93c32b395/82c27dc2-1234-49aa-836e-1bd31760a4c0`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.2 Project Team Culture </p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/89b8cb38-5a1d-48f0-a41c-2f9a3d6dc30d/a0530f06-5653-4e18-bc60-ea403164e53d`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.3 High-Performing Project Teams</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/bb7ae0d5-ce01-4185-a456-0276b495b545/56b0bdf7-3e4b-485d-928c-41e8a0d05a06`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.4 Leadership Skills</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/ba9517fd-ca4a-4144-bd5e-98555edabff7/20b5a3d8-6859-48b3-ab1d-c0659a69a11e`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.5 Tailoring Leadership Styles</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/133adac3-f317-42c5-95f2-46435f795865/94e6dbf6-7c09-4537-8c71-0ea4e78b21ab`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.6 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/57eeca66-fcde-408f-9edf-b681cf01f362/5f73ff90-7059-4551-8e26-e8867d5c8dd0`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.2.7 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/acc376ae-fd12-44c9-9bfb-c3e405416c27/b5bf2087-3de8-4a05-b31d-bb5a67543560`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3 Development Approach and Life Cycle Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/adeb4426-9cae-4e00-a957-c4385548fa54/2338ace2-1e90-4221-99fa-793878c15ecf`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.1 Development, Cadence, and Life Cycle Relationship</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/f8bcf0d5-eb07-4bbc-8e7f-92fe7bb43fa6/2e2bf55f-e7a3-449f-a694-464c9621f66c`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.2 Delivery Cadence</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/a7396cdd-f53b-4203-9d9a-c0aac57be343/45b99f7a-9dfb-4e95-8cfe-40676da8ba8a`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.3 Development Approaches</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/5e2287bd-9bf6-4096-8a28-3c44ced42192/0292a393-6b18-4834-b5a5-965460fd314e`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.4 Considerations for Selecting a Development Approach</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/c9018067-18c1-49e7-8e4d-fb89a6fc96d3/6ca8b4c5-112f-4876-8e06-039c03a08185`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.5 Life Cycle and Phase Definitions</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/0543bf55-f7f5-4931-9c3d-dc70d7d73df3/be713e14-a0ae-4492-a525-51d6e7d0d8fe`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.6 Aligning of Delivery Cadence, Development Approach, and Life Cycle</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/7c550210-ba16-46fd-a872-fca648baea19/34c9cb9f-4329-4a4a-ac25-a379df80fd45`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.7 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/ca50c63f-9cd2-4505-abd0-a896a5d55c51/834afcd4-9937-4f49-91c7-a5f8d11ba607`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.3.8 Measuring Outcomes</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/95565287-49bd-47dd-a0ce-965e77fc2c44/1752e378-c16f-47ea-90a9-5c32c4591c3e`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4 Planning Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/210a5367-6956-4c52-98ca-42ed0b096e11/7ea75be3-0aab-44bd-b42a-0af1e3478109`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.1 Planning Overview</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/dc460df8-bedc-4ea5-a776-7610f58815fd/58fe8301-ad23-43da-ac7a-846f769a4b79`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.2 Planning Variables</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/78e2f78d-ad28-472c-a779-ea2ee4c8dcc9/cb773eeb-51fd-4b2f-a904-e64387c0b22f`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.3 Project Team Composition and Structure</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/2f7b6f39-6d03-4cd4-bb56-8445b25a8bf7/0c346e74-13aa-4826-b88a-82190a0055e6`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.4 COMMUNICATION</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/2cd140cb-7f18-4dfe-a3da-5bb2cd1fd86b/0162cdf1-bcf3-4541-9cfc-f41331a49276`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.5 Physical Resources</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/0fa973d2-0f9a-4431-8c56-6f3a0fda098a/fb6b7a3e-08c1-44b1-8e10-ded12eed76ed`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.6 Procurement</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/e1e95e76-0f78-4104-b90d-bccfd9fd5523/d8ee5da0-55ea-4642-b0a0-e6ace4b9a09d`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.7 Changes</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/fb912384-c2b1-41a3-b242-775edc150f53/a6d57440-f9b0-4403-b3bb-a07b751221f1`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.8 Metrics</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4a71e167-7a13-4069-98e4-87e5762cfdd3/f87e2eb2-050d-41e2-aa77-6a7eec589c09`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.9 Alignment</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/42b3f8da-ec01-4713-98be-49ca8935ecce/7401515e-7d17-4838-b1c6-10ab4cd25339`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.10 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/dcf24b60-895d-4000-bb36-080207248453/abc66209-5376-475b-9b3d-2b7c1288ffb8`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.4.11 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/580ac387-7fcc-4791-a7c4-99de7e4214c8/fd3f3ec6-35c6-41af-a17b-dfe354e708f4`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5 Project Work Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/98dd3d79-ebed-42a5-bf35-a93dd3e17bc2/a2920408-916e-42a2-be62-eb908189f400`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.1 Project Processes</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/5cd83f70-fc83-4ef5-96d0-d2ace09ac0f5/400a9494-514c-4d7b-99dc-69f5daf84289`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.2 Balancing Competing Constraints</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/560db007-208c-4472-a9a1-72a449be795b/e1c77f8d-d6bd-40e7-9b34-27c702003b85`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.3 Maintaining Project Team Focus</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/10d905a6-062a-49b4-b067-8378ebc90aa3/a3f4f97d-99c3-4398-b697-54d03b767165`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.4 Project Communications and Engagement</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/84c503a5-8a3e-48a7-bc36-4e27a61c8814/f253b821-d1a3-434b-a7d8-d2436047adae`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.5 Managing Physical Resources</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/80dc2ca3-7378-4b0d-bed4-6e170c0be81c/f904d2c3-b5bd-4e66-89c7-c042063842df`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.6 Working with Procurements</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4d1377be-5fb0-47c7-9ab8-13b0a360cbf2/816d74e5-8ea8-459c-b43b-c7a753c046fa`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.7 Monitoring New Work and Changes</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/40e12db0-cb30-46af-bf5f-49f468378195/7ae15bc9-a390-49ec-be7d-dc06f77c4d6a`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.8 Learning throughout the Project</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/fb6e16da-106c-4110-89bc-c1ed10aab3d2/4717c5dc-559c-4e2f-9974-75b82a294cba`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.9 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/b109cace-37c4-4ee1-89fd-ab1eba7ff69d/4b5bbc95-b55a-49bf-a19e-d6f3f01170fb`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.5.10 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/c42e8317-9542-49de-ac19-c9266339ad16/3476433e-e890-4c85-900b-267042523f13`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6 Delivery Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/c5c57316-7c4d-435b-bc5e-bc309d453156/ff05138a-f7dd-45a8-a731-7cd1594255b6`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.1 Delivery of Value</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/6223d6f8-a61f-4568-8f17-6a6e2d5a8a84/0a745b26-619b-4130-997e-29c059a4e754`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.2 Deliverables</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/418226ec-bd26-40aa-940c-0f4becdd81e8/1b24d029-80c5-4dda-a6f1-e846e847afa8`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.3 Quality</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/9d5db034-2d30-4541-bdd0-7f6783a3bc4a/f1940699-d3ec-4444-964c-30fb759bf4fb`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.4 Suboptimal Outcomes</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/88ddbd1f-4bc9-443c-8b84-a3847bc12a27/460ea99b-2df1-45bc-a98d-963278820ffa`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.5 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/6b9eb6d2-931a-47f2-98cb-49c7e632c4ef/6421437a-6bc6-4e97-9cb9-3664657eaf30`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.6.6 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/838e480b-1131-433f-b029-00bd07584868/201ae1c2-e3ae-4703-a74b-913123887e67`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7 Measurement Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/49171f65-a992-412c-b148-21fecf7dda05/efc5d47c-7762-4a1b-847f-b7a43e26d1e9`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.1 Establishing Effective Measures</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/f9fe13f4-fdb2-4f55-8374-834d1d034615/a0a35d68-bbe5-4352-85ac-50c8959eb4dd`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.2 What to Measure</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4d7d195e-f0ef-4456-8fea-cc831b16eadc/0a0fd02a-d800-407d-be4f-83edfe956477`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.3 Presenting Information</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/6420496d-e5c9-4560-b0c9-3ce392c7ad1a/c80332b2-3262-4d9f-8bcb-0154e81cf9f9`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.4 Measurement Pitfalls</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/22a7dd29-9d62-4616-ba70-28dbb3f04dd3/14c1521c-6992-403d-8e78-2afd5eddbbad`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.5 Troubleshooting Performance</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/d6c1acf3-948d-4133-bec0-a64a2fb359cd/7ec5f966-c029-4357-97f0-83908e26e109`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.6 Growing and Improving</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/1aa81cc3-fbf1-4e22-b3da-65352499dd03/4a2fb61d-2a85-43ba-ab5c-b09b4e027391`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.7 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/8b8751e2-0aa6-4267-8e2f-94f1ea9b4eda/3a6999bf-b5f5-45bc-ac7a-778cd74946e0`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.7.8 Checking Results</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/059211bd-8a53-4db6-922e-458c8c087153/518195cf-4580-4436-9df9-8a0c148a0075`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8 Uncertainty Performance Domain</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/bba1f317-be0b-42ff-ba68-1850d8a82b46/285ebc21-77e5-436f-95fd-4080bb725c32`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.1 General Uncertainty</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/0ee1b009-d385-4127-bde1-1622d9787f11/a8936e89-542f-4203-b0c8-0107623479b3`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.2 Ambiguity</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/28e14183-840f-4665-b87a-e0620e57f15c/439eae4c-2991-4ede-9ecf-4fa2d93cf119`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.3 Complexity</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/a32fa545-9ae4-4f95-b7ac-f6528a9ba2f9/f9a569f0-83fc-4be6-86c3-3ea20ff8727b`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.4 Volatility</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/42d86d27-9432-44dd-85b1-38c146700e33/58b1b696-c868-4323-9376-d9ebc9115006`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.5 Risk</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/96478963-5001-45d7-97a7-6de42b903ea5/5ccba717-add7-42c9-b85f-483d49c4e783`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.6 Interactions with Other Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/b1388b6a-65a6-4dff-881b-814fa0379182/5aa98bf0-b72f-445c-b912-c49d6286e2d5`}
        target="_self"
        onClick={closeModal}
      >
        <p >2.8.7 Checking Results</p>
      </Link><br />

      <Link
        className='inline-block resource-topic pl-8 font-bold mb-2'
        to={`/posts/5615d769-2ecf-4b70-87a9-8c0d657339be/16988372-85c4-4718-8a7e-ec41c458d79b`}
        target="_self"
        onClick={closeModal}
      >
        <h4>3. TAILORING</h4>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/bea72caa-c09a-4284-9b03-37c68df8116b/1489e6ec-ac3b-463f-bab6-0e53fd5ef950`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.1 Overview</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/7ffe03f6-613c-4e3c-afb0-7d5fbc1bee7c/30cc6f86-fc5a-42a5-a49e-537fe4453701`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.2 Why Tailor?</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/c65cbd2c-fc44-42ca-ad6c-ffb25a74b85f/567234b4-1036-4303-bad6-a59bec23e4d1`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3 What to Tailor</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/b9084b9e-6bf0-408d-9c99-82503198ad43/a2091a99-429f-459e-b69c-b2c8d627d92b`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3.1 Life Cycle and Development Approach Selection</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/a7892c00-2a59-466d-a2f9-bff8ff8310c5/d387edf6-e72d-453e-b739-e300acf5d189`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3.2 Processes</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/7562b9f1-0018-47c7-82c6-de4d5e1718e0/68dfef38-61de-41ee-864c-cc0491c53a8e`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3.3 Engagement</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/b976541b-5566-4bcd-a939-f2076ac1b065/aaa55275-21f5-4962-b2c9-cc9dfa2cd176`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3.4 Tools</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/e375f4c9-d69a-446c-86b8-103bbdf2bb85/74c4459c-7391-4475-a4f8-cc3b72ceb6ee`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.3.5 Methods and Artifacts</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/e2662bc5-a334-46da-a7f3-ccab8d429532/34191d0f-b20e-44ec-8dd8-8dd598fd05ed`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.4 The Tailoring Process</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/f8f867bf-f2a2-41e0-a70d-5568b2519427/4f59ec93-fdd0-4aa1-b065-278d9f1f6490`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.4.1 Select Initial Development Approach</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4d78ba2e-1c40-424a-8a6f-420d55b9a5ad/6f956cfb-01ed-4e48-a0ed-53522f9cbfe1`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.4.2 Tailor for the Organization</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/8319c254-c62c-4fca-b5c8-a4a578e390c9/2f4318ce-f59b-45db-a996-3e0f54e78532`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.4.3 Tailor for the Project</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/46f65c4a-9de9-484e-a062-2895ccd6b062/6f524683-8974-4c06-a9bc-2f616a0b8f63`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5 Tailoring the Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/037638dc-d8bc-462d-8975-d0590f9cb40b/50c6a21a-f8b5-4221-be74-e639fa6020ed`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.1 Stakeholders</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4e9add75-379d-49c1-baa3-a6034870197b/4d03bff5-6fd9-42e9-8f48-930aebb867b6`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.2 Project Team</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/247dd061-4973-4033-adfb-47d44f65a7c2/c7f546af-2f77-4aaf-85c2-06bf4ef0f5e1`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.3 Development Approach and Life Cycle</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/94103ee6-0096-449b-83f4-b2ae412986cb/7e081a14-3160-43de-b95b-38cfc682b7e1`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.4 Planning</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/9c3c1f0c-3a5a-47be-9efd-c08373b4c9d8/d4a4116b-dfe8-44d9-b29b-3edcade4997f`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.5 Project Work</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/f7d30d3d-dcac-432d-a0fb-091db840f190/098c20c0-a792-472f-b1b1-e0b46011f89d`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.6 Delivery</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/77710686-27c1-4907-a69d-1978d22affbe/51af37f1-55f1-4405-9415-2e94638ea79b`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.7 Uncertainty</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/9987a75b-3ab2-43c2-b0da-b39a06e0cd2c/c0c870ed-2640-4331-b19e-8cc7a5c23032`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.5.8 Measurement</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/1f1c766c-b63a-4724-8c76-3cead0e97298/7fc94e29-8ea6-4114-9158-62db341e5aed`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.6 Diagnostics</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/1d514d8a-5e53-48cd-b928-9fb1acffacce/63e3fae9-5639-4470-8a70-36c061f9271f`}
        target="_self"
        onClick={closeModal}
      >
        <p >3.7 Summary</p>
      </Link><br />
      <h4 className='resource-topic pl-8 font-bold mb-2'>4. MODELS, METHODS, AND ARTIFACTS</h4>
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/af0ade21-075c-4909-ba39-79d450f1f5a6/c4034116-a4df-41c1-b50d-ddf0c84a8521`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.1 Overview</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/2df16dd7-393d-4682-b03b-f519003cac80/bea17767-b06b-4fd0-a4c8-e720c588b9a8`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2 Commonly Used Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/b4f868b8-ec9f-48ca-b4b1-2ff5a2ac3626/4ac58fc9-a247-4d9a-92d0-e617319bcbaf`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.1 Situational Leadership Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/556d149f-fd2d-48cf-891b-a55ba845d60e/81e80cb4-bf0a-44d9-a8b7-e62f5576e4d9`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.2 Communication Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/de2046f9-b17f-48c6-8464-341b2c2c9683/aa89750b-420f-42c4-8fd7-477b95316c09`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.3 Motivation Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/ade034aa-7820-4e71-b130-a758c0301726/2a7a75db-4b09-4548-bb5c-1de8365e27c1`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.4 Change Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/c157505b-479d-4044-a0f8-a482e010fb43/e4612fb3-8c02-461d-b6d6-e164e8276e2a`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.5 Complexity Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/0c3fdd1c-d6ed-4565-9d1b-01f5ae13d0b4/7cc83cf9-8313-4351-a6e4-403769d1d41d`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.6 Project Team Development Models</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/a44ec098-7aa9-448f-be10-0fe7a524d736/50988814-407b-43f1-9903-0b73b8f29468`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.2.7 Other Models</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/8aaf9b37-e574-4cb6-893e-5e874b4a2620/d08830c7-fe12-4906-a0b7-8d405d8fa0c8`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.3 Models Applied Across Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/cd7971c1-d4db-4451-974b-0435539d39ec/3debfc42-201d-40d8-8846-589441ad73ab`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.4 Commonly Used Methods</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/5a35aaa2-efcd-4702-b17b-c9e2c421efff/7ffbe255-6f5f-4bc5-841a-7448fd4123a7`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.4.1 Data Gathering and Analysis</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/be80249e-624a-4ed9-bd7a-0feca691bb96/4832acd5-a5ae-46e1-901d-030ee1ff6350`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.4.2 Estimating</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/d2e993ef-139d-483d-b9ac-0e79083b40b8/b1dcfeb4-7a88-404c-9b5c-6748c0491957`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.4.3 Meetings and Events</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/4ee45b1c-68c1-4ead-84c7-c3736cf32f11/a549d6bd-89f2-401b-97c7-3df1e4d2ded2`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.4.4 Other Methods</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/ad509ef7-14cf-459a-83c8-dd67356d9393/daba838a-eaed-4ab2-a448-2dbae1c9dcc9`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.5 Methods Applied Across Performance Domains</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/e029117e-8eab-4e47-ac80-7bb4f31d77d9/2aec3d90-c7ef-403c-8a96-848c1354d16d`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6 Commonly Used Artifacts</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/1eb9e94a-ca8d-4bb1-b0d7-af8eb45ce51b/63b714c2-123c-4532-bb3e-6ad867e66031`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.1 Strategy Artifacts</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/ebd97042-18b6-4241-a0cb-08edc5ec3d5a/2c5b2899-70bd-4d28-aa39-139cc35d636`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.2 Logs and Registers</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/ebee5581-fbf3-49cb-ab8b-312569f25643/0404be40-0683-413b-a43e-8ce1ebf42510`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.3 Plans</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/12324a9f-9619-45fd-a28c-b35b07b3334c/67d06e95-3751-4344-b24f-8fee550d5acd`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.4 Hierarchy Charts</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/7f31693d-b338-41de-a1d9-4427c1f3536d/757f58a5-ff4e-4d9c-b45c-fbec85103be3`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.5 Baselines</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/c481e77e-2f6d-48b6-9b1c-a1a7b6acc050/b2927fdb-44d6-4d29-95d4-c3f44aa98dae`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.6 Visual Data and Information</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/82525d73-6a1f-453e-8711-95d63309ded4/bf1226e9-61ea-4f9d-8831-081e06e1e4a4`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.7 Reports</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/691b2d18-1286-4b67-909e-4175799c86f4/2f5a9584-52b8-49ce-b4f1-a57a4f72986c`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.8 Agreements and Contracts</p>
      </Link><br />
      <Link
        className='inline-block resource-sub-fragment ml-24 mb-2'
        to={`/posts/57c34ac0-51c2-493d-ad11-627c22d785d9/60de1f9f-dc58-40ab-998e-e3b63397f056`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.6.9 Other Artifacts</p>
      </Link><br />
      <Link
        className='inline-block resource-fragment ml-16 mb-2'
        to={`/posts/2ead2ec5-f915-4b5d-ab00-623b484733c9/0e83b262-74f3-4e82-be79-cf4a37f9618a`}
        target="_self"
        onClick={closeModal}
      >
        <p >4.7 Artifacts Applied Across Performance Domains</p>
      </Link><br />
    </div>
  );
};

export default PmbokSevenToc;
